import { defineComponent as c, computed as t, createBlock as i, openBlock as d, unref as r, normalizeClass as n, withCtx as m, createCommentVNode as p, renderSlot as v } from "vue";
import { RevButtonBase as g } from "@ds/components/ButtonBase";
import { RevSpinner as y } from "@ds/components/Spinner";
import { tw as a } from "../../utils/tailwind.js";
const C = /* @__PURE__ */ c({
  name: "RevButtonCard",
  __name: "ButtonCard",
  props: {
    ariaDescribedby: { default: void 0 },
    ariaLabelledby: { default: void 0 },
    ariaLabel: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    loadingAlternativeText: { default: void 0 },
    to: { default: void 0 },
    tracking: { default: () => ({}) }
  },
  emits: ["click"],
  setup(s) {
    const l = s, u = t(() => [
      a`shadow-short rounded-lg relative block no-underline motion-safe:transition motion-safe:duration-200 motion-safe:ease-in`,
      l.disabled ? a`bg-float-default-low-disabled cursor-not-allowed saturate-0` : a`bg-float-default-low focus-visible-outline-default-hi cursor-pointer hover:bg-float-default-low-hover hover:shadow-long`,
      l.disabled && !l.loading && a`[&>*]:opacity-70`,
      l.loading && a`overflow-hidden [&>*:not(:first-child)]:invisible`
    ]), f = t(() => [
      a`absolute left-0 top-1/2 -mt-12 w-full`,
      l.disabled ? a`text-action-default-hi-disabled` : a`text-action-default-hi`
    ]);
    return (e, o) => (d(), i(r(g), {
      "aria-describedby": e.ariaDescribedby,
      "aria-label": e.loading ? e.loadingAlternativeText : e.ariaLabel,
      "aria-labelledby": e.ariaLabelledby,
      class: n(u.value),
      disabled: e.disabled,
      to: e.to,
      tracking: e.tracking,
      onClick: o[0] || (o[0] = (b) => e.$emit("click", b))
    }, {
      default: m(() => [
        e.loading ? (d(), i(r(y), {
          key: 0,
          "alternative-text": "",
          class: n(f.value)
        }, null, 8, ["class"])) : p("", !0),
        v(e.$slots, "default")
      ]),
      _: 3
    }, 8, ["aria-describedby", "aria-label", "aria-labelledby", "class", "disabled", "to", "tracking"]));
  }
});
export {
  C as default
};
